import { render } from "./RhNotification.vue?vue&type=template&id=79792bc0"
import script from "./RhNotification.vue?vue&type=script&lang=js"
export * from "./RhNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__